<template>
    <div class="ui centered grid">
    <div class="sixteen wide column ">
        
        <form class="ui form" style="padding:30px;" id="userform" method="post">
            <input v-if="!blank" type="hidden" name="uuid"  v-bind:value="userData.uuid">
            <h4 class="ui dividing header">User settings</h4><br>
            <div v-if="!settings" class="two fields" >
                <div class="field">
                    <label>Username</label>
                    <input type="text" placeholder="Username" name="username" v-bind:value="userData.username">
                </div>
                <div class="field">
                    <label>Role</label>
                    <div class="ui selection dropdown" id="roleSelect">
                        <input type="hidden" name="role">
                        <i class="dropdown icon"></i>
                        <div class="default text">Role</div>
                        <div class="menu">
                            <div class="active item" data-value="user">User</div>
                            <div class="item" data-value="contributor">Contributor</div>
                            <div class="item" data-value="admin">Admin</div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="field">
                <label>Name</label>
                <div class="two fields">
                    <div class="field">
                        <input type="text" name="first_name" placeholder="First Name" v-bind:value="userData.first_name">
                    </div>
                    <div class="field">
                        <input type="text" name="last_name" placeholder="Last Name" v-bind:value="userData.last_name">
                    </div>
                </div>
            </div>
            <div class="four wide field">
                <label>Notes Color</label>
                <div class="ui fluid selection dropdown" id="notes_color">
                  <input type="hidden" name="notes_color">
                  <i class="dropdown icon"></i>
                  <div class="default text">color</div>
                  <div class="menu">
                      
                    <div v-for="color in colors" class="item" v-bind:data-value="color" :key="color" v-bind:style="{'background-color':color}">
                      {{color}}
                    </div>
                    
                  </div>
                </div>
            </div>
            <div v-if="!settings" class="four wide field">
                <label>Avatar File Name</label>
                <input type="text" placeholder="File Name" name="avatar" v-bind:value="userData.avatar">
                
            </div>
            <div class="field">
                <label>Email</label>
                <input type="text" placeholder="Email" name="email" v-bind:value="userData.email">
            </div>
            <div class="field">
                <label>Password</label>
                <input type="password" placeholder="Password" name="password">
            </div>
        <!--    <div v-if="settings" class="field">
                <label>Confirm Password</label>
                <input type="password" placeholder="Confirm Password" name="confirm_password">
            </div>-->
          
            <br><br>
          
            <button v-if="blank" class="ui blue right floated button">Create User</button>
            <button v-if="!blank" class="ui blue right floated button">Update User</button>
            <button class="ui right floated button"  v-on:click="cancel()" style="margin-right:5px">Cancel</button>
             <br><br>
             <div class="ui error message"></div>
        </form>
    </div>
</div>


</template>

<script>
    export default {
        props: ['userData', 'settings', 'blank'],
        data() {
            return {
                colors: ['#CFAFAF', '#FFAAAA', '#FFBAA4', '#F7A06D', '#FFD8B3', '#FFEF99', '#F2EEC2', '#DDDDA8', '#D3DEB3', '#C1D7AE', '#AEDFB5', '#B0D8CB', '#B4E7E2', '#D6F6F6', '#AFE2EB', '#ACD9F2', '#B9DBF8', '#C3CBD5', '#AEBBE2']
            }
        },
        methods: {
            cancel: function() {
                this.$emit('formClose', 0);
            },
        },
        watch: {
            userData: function(val) {
                $('#notes_color').dropdown('set selected', this.userData.notes_color);

            }
        },
        mounted() {
            var role = this.userData.role;
            var notes_color = this.userData.notes_color;
            console.log(notes_color);
            var myThis = this;
            var fields = {
                username: 'empty',
                role: 'empty',
                first_name: 'empty',
                last_name: 'empty',
                email: 'email',
            }
            if (this.blank) {
                fields.password = ['minLength[6]', 'empty'];
            }
            if (this.settings) {
                // fields.password = ['minLength[6]', 'empty'];
                fields.confirm_password = 'match[password]';
            }
            setTimeout(function() {
                $('#roleSelect').dropdown('set selected', role);
                $('#notes_color').dropdown({
                    onChange: function(val) {
                        $('#notes_color').css("background-color", val);
                    },

                }).dropdown('set selected', notes_color);
                $('#userform').form({
                    on: 'blur',
                    fields: fields,
                    onSuccess: function(event, fields) {
                        event.preventDefault();
                        console.log("Calling onSuccess");
                        var formArray = $('form').serializeArray();
                        var postBody = {};
                        for (var i in formArray) {
                            postBody[formArray[i].name] = formArray[i].value;
                        }
                        if (myThis.settings) {
                            delete postBody.confirm_password;
                            delete postBody.username;
                        }

                        if (myThis.blank) {
                            axios.post('/api/user', postBody)
                                .then(function(response) {
                                    console.log(response.status);
                                    myThis.$emit('formClose', response.status);
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    myThis.$emit('formClose', error.response.status);
                                });
                        }
                        else {
                            axios.put('/api/user', postBody)
                                .then(function(response) {
                                    console.log(response);
                                    myThis.$emit('formClose', response.status);

                                })
                                .catch(function(error) {
                                    console.log(error);
                                    myThis.$emit('formClose', error.response.status);
                                });
                        }
                    }
                });
            }, 100);;

        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .colorSq {
        width: 100%;
        height: 100%;
        background-color: lightblue;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheUserForm.vue